const resource = "languageTags";

export default ($axios) => ({
	// GET
	getLanguageTags(type, typeId, params={}) {
		return $axios.get(`/${resource}/${type}/${typeId}`, { params } );
	},
	// PUT
	updateLanguageTag(tag, type, typeId) {
		return $axios.put(`/${resource}/${type}/${typeId}/${tag.id}`, tag)
	},
	updateLanguageTags(tags, type, typeId) {
		return $axios.put(`/${resource}/${type}/${typeId}`, tags)
	},
	saveLanguageTags(tags, type, typeId) {
		return $axios.put(`/${resource}/${type}/${typeId}`, tags)
	},
	// POST
	createLanguageTag(tag, type, typeId) {
		return $axios.post(`/${resource}/${type}/${typeId}`, tag)
	},
	// DELETE
	deleteLanguageTag(tag, type, typeId) {
		return $axios.delete(`/${resource}/${type}/${typeId}/${tag.id}`, tag)
	},
});
